window.showYear = function (year, btn) {
    const target = document.getElementById('year-' + year);

    target.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
    })

    btn.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest',
    })

    document.querySelectorAll('#year-tabs button').forEach(b => {
        b.classList.remove('border-red-500', 'font-normal');
        b.classList.add('border-platinum');
    });

    btn.classList.add('border-red-500', 'font-normal');
    btn.classList.remove('border-[#D9D9D9]');
};
